import React from 'react';

import { useTranslation } from "core/hooks/useTranslation";

import Tabs from "components/common/tabs";

import Web from './web';
import AppRedirections from './appsRedirections'

const RedirectionLinks = () => {
    const { t } = useTranslation();

    const items = [
        {
            title: t("backoffice.campaigns.web"),
            component: <Web/>
        },
        {
            title: t("backoffice.campaigns.appsRedirections"),
            component: <AppRedirections />
        }
    ]

    return (
        <Tabs.SubTabs 
            items={items}
        />
    )
}

export default RedirectionLinks;